/**
 * WebPremiumStorePage — Premium Store for ahobilam.com website
 * Integrates with Instamojo for direct UPI/Card payments
 * After payment, code is auto-generated and shown + emailed
 */
import { useState } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://ahobilam.com';
const API = BACKEND_URL.endsWith('/api') ? BACKEND_URL : `${BACKEND_URL}/api`;

const PLANS = [
  { id: 'pay_per_use_jathagam', name: 'ஜாதகக் கணிப்பு (1 பயன்பாடு)', nameEn: 'Jathagam / Casting (Per Use)', desc: 'ஜாதகம் கணிப்பு & PDF அறிக்கை (ஒருமுறை பயன்பாடு)', price: 20, popular: true },
  { id: 'pay_per_use_matching', name: 'திருமண பொருத்தம் (1 பயன்பாடு)', nameEn: 'Marriage Matching (Per Use)', desc: '10/12 ஜாதகப் பொருத்தம் & PDF (இரு ஜாதகக் கணிப்பு)', price: 50, popular: true },
  { id: 'pay_per_use_muhurtham', name: 'சுப முஹூர்த்தம் (1 பயன்பாடு)', nameEn: 'Good Days / Muhurtham (Per Use)', desc: 'நல்லநாள், சிறப்பு முஹூர்த்தம் அறிக்கை (ஒருமுறை பயன்பாடு)', price: 20, popular: false },
  { id: 'pay_per_use_panchangam', name: 'பஞ்சாங்கம் அறிக்கை (1 பயன்பாடு)', nameEn: 'Panchangam Report (Per Use)', desc: 'விரிவான பஞ்சாங்கம் PDF (ஒருமுறை பயன்பாடு)', price: 20, popular: false },
];

const WebPremiumStorePage = () => {
  const [selectedPlan, setSelectedPlan] = useState('pay_per_use_jathagam');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [step, setStep] = useState('select'); // select | form | processing

  const currentPlan = PLANS.find(p => p.id === selectedPlan);

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      if (window.Razorpay) {
        resolve(true);
        return;
      }
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const handlePayment = async (e) => {
    e.preventDefault();
    setError('');

    if (!name.trim() || !email.trim() || !phone.trim()) {
      setError('Please fill all fields');
      return;
    }
    if (!/^\d{10}$/.test(phone.replace(/\D/g, '').slice(-10))) {
      setError('Please enter a valid 10-digit phone number');
      return;
    }

    setLoading(true);
    try {
      const isLoaded = await loadRazorpayScript();
      if (!isLoaded) {
        setError('Failed to load Razorpay SDK. Please check your internet connection.');
        setLoading(false);
        return;
      }

      // 1. Create Order
      const response = await fetch(`${API}/payments/razorpay/create-order`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          amount: currentPlan.price,
          currency: 'INR',
          receipt: `web_${Date.now()}`,
          notes: {
            productId: selectedPlan,
            name: name.trim(),
            email: email.trim(),
            phone: phone.trim()
          }
        }),
      });

      const orderData = await response.json();

      if (orderData && orderData.order_id) {
        // 2. Open Razorpay Checkout
        const options = {
          key: orderData.key_id,
          amount: orderData.amount,
          currency: orderData.currency,
          name: "Sri Paranthaman Panchangam",
          description: currentPlan.name,
          order_id: orderData.order_id,
          handler: async function (response) {
            setStep('processing');
            try {
              // 3. Verify Payment
              const verifyRes = await fetch(`${API}/payments/razorpay/verify-payment`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  razorpay_order_id: response.razorpay_order_id,
                  razorpay_payment_id: response.razorpay_payment_id,
                  razorpay_signature: response.razorpay_signature,
                  email: email.trim(),
                  phone: phone.trim()
                })
              });
              
              const verifyData = await verifyRes.json();
              if (verifyData.success && verifyData.vipCode) {
                setStep('success');
                setError(verifyData.vipCode); // Store VIP code in error state temporarily just to show it, or we can use a new state.
              } else {
                setError('Payment verified but VIP Code generation failed. Contact Support.');
                setStep('form');
              }
            } catch (err) {
              setError('Failed to verify payment on server.');
              setStep('form');
            }
          },
          prefill: {
            name: name.trim(),
            email: email.trim(),
            contact: phone.trim()
          },
          theme: {
            color: "#1B5E20"
          }
        };

        const rzp = new window.Razorpay(options);
        rzp.on('payment.failed', function (response){
          setError("Payment failed: " + response.error.description);
          setStep('form');
        });
        rzp.open();
      } else {
        setError(orderData.detail || 'Failed to initialize payment gateway.');
      }
    } catch (err) {
      setError('Network error. Please check your connection and try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '80vh', background: 'linear-gradient(135deg, #E8F5E9 0%, #FFF3E0 100%)', padding: '24px 16px' }}>
      <div style={{ maxWidth: '700px', margin: '0 auto' }}>
        
        {/* Hero Header */}
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <h1 style={{ color: '#1B5E20', fontSize: '2rem', marginBottom: '8px', fontFamily: "'Noto Sans Tamil', 'Inter', sans-serif" }}>
            🙏 பரந்தாமன் Premium Store
          </h1>
          <p style={{ color: '#666', fontSize: '1rem', maxWidth: '500px', margin: '0 auto' }}>
            Unlock all premium features of Sri Paranthaman Panchangam app. Pay directly — no Google Play needed!
          </p>
          <div style={{ display: 'inline-block', marginTop: '12px', background: '#FFF3E0', borderRadius: '20px', padding: '6px 16px', fontSize: '13px', color: '#E65100', fontWeight: 600 }}>
            💰 Zero commission • Direct to developer • Instant activation
          </div>
        </div>

        {/* Plans Grid */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '16px', marginBottom: '24px' }}>
          {PLANS.map(plan => (
            <div 
              key={plan.id}
              onClick={() => { setSelectedPlan(plan.id); setStep('form'); }}
              style={{
                background: selectedPlan === plan.id ? '#E8F5E9' : 'white',
                border: selectedPlan === plan.id ? '3px solid #1B5E20' : '2px solid #e0e0e0',
                borderRadius: '16px',
                padding: '20px',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                position: 'relative',
                boxShadow: selectedPlan === plan.id ? '0 4px 16px rgba(27,94,32,0.2)' : '0 2px 8px rgba(0,0,0,0.06)',
              }}
            >
              {plan.popular && (
                <div style={{ position: 'absolute', top: '-10px', right: '12px', background: '#FF6F00', color: 'white', padding: '3px 12px', borderRadius: '12px', fontSize: '11px', fontWeight: 800 }}>
                  ⭐ BEST VALUE
                </div>
              )}
              <h3 style={{ margin: '0 0 4px', color: '#1B5E20', fontSize: '1.1rem' }}>{plan.name}</h3>
              <p style={{ margin: '0 0 8px', fontSize: '13px', color: '#666' }}>{plan.desc}</p>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: '1.5rem', fontWeight: 800, color: '#1B5E20' }}>
                  ₹{plan.price} <span style={{ fontSize: '0.7rem', color: '#888', fontWeight: 400 }}>/ year</span>
                </span>
                {selectedPlan === plan.id && (
                  <span style={{ background: '#1B5E20', color: 'white', padding: '4px 12px', borderRadius: '12px', fontSize: '12px', fontWeight: 700 }}>✓ Selected</span>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Payment Form */}
        {(step === 'form' || step === 'processing') && currentPlan && (
          <div style={{ background: 'white', borderRadius: '16px', padding: '24px', boxShadow: '0 4px 16px rgba(0,0,0,0.08)', marginBottom: '24px' }}>
            <h2 style={{ color: '#1B5E20', fontSize: '1.2rem', margin: '0 0 4px' }}>
              💳 Complete Payment — {currentPlan.name}
            </h2>
            <p style={{ color: '#888', fontSize: '13px', margin: '0 0 20px' }}>Amount: ₹{currentPlan.price}/year</p>

            {error && step !== 'success' && (
              <div style={{ background: '#FBE9E7', color: '#C62828', padding: '10px 16px', borderRadius: '8px', marginBottom: '16px', fontSize: '14px' }}>
                ❌ {error}
              </div>
            )}

            {step === 'processing' ? (
               <div style={{ textAlign: 'center', padding: '40px 20px' }}>
                 <h3 style={{ color: '#1B5E20' }}>Processing Payment...</h3>
                 <p style={{ color: '#666' }}>Please wait while we verify your transaction and generate your code.</p>
               </div>
            ) : (
            <form onSubmit={handlePayment}>
              <div style={{ marginBottom: '16px' }}>
                <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, color: '#333', marginBottom: '4px' }}>Full Name / பெயர் *</label>
                <input 
                  type="text" value={name} onChange={e => setName(e.target.value)} 
                  placeholder="Enter your name"
                  style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '2px solid #e0e0e0', fontSize: '15px', boxSizing: 'border-box', outline: 'none' }}
                  required
                />
              </div>
              <div style={{ marginBottom: '16px' }}>
                <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, color: '#333', marginBottom: '4px' }}>Email / மின்னஞ்சல் *</label>
                <input 
                  type="email" value={email} onChange={e => setEmail(e.target.value)} 
                  placeholder="your@email.com"
                  style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '2px solid #e0e0e0', fontSize: '15px', boxSizing: 'border-box', outline: 'none' }}
                  required
                />
                <p style={{ fontSize: '11px', color: '#888', margin: '4px 0 0' }}>Activation code will be sent here</p>
              </div>
              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, color: '#333', marginBottom: '4px' }}>Phone Number / தொலைபேசி *</label>
                <input 
                  type="tel" value={phone} onChange={e => setPhone(e.target.value)} 
                  placeholder="10-digit mobile number"
                  style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '2px solid #e0e0e0', fontSize: '15px', boxSizing: 'border-box', outline: 'none' }}
                  required
                />
              </div>

              <button 
                type="submit" 
                disabled={loading}
                style={{ 
                  width: '100%', padding: '14px', background: loading ? '#aaa' : 'linear-gradient(135deg, #1B5E20, #2E7D32)', 
                  color: 'white', border: 'none', borderRadius: '12px', fontSize: '1.1rem', fontWeight: 800, 
                  cursor: loading ? 'not-allowed' : 'pointer', boxShadow: '0 4px 12px rgba(27,94,32,0.3)',
                  transition: 'all 0.2s ease'
                }}
              >
                {loading ? '⏳ Loading Razorpay...' : `🔒 Pay ₹${currentPlan.price} Securely`}
              </button>

              <div style={{ display: 'flex', justifyContent: 'center', gap: '12px', marginTop: '12px', fontSize: '12px', color: '#888' }}>
                <span>💳 UPI</span>
                <span>•</span>
                <span>🏦 Cards</span>
                <span>•</span>
                <span>📱 GPay/PhonePe</span>
                <span>•</span>
                <span>🏧 NetBanking</span>
              </div>
            </form>
            )}
          </div>
        )}

        {/* Success State */}
        {step === 'success' && (
          <div style={{ background: '#E8F5E9', border: '3px solid #4CAF50', borderRadius: '16px', padding: '32px', textAlign: 'center', marginBottom: '24px' }}>
            <h2 style={{ color: '#2E7D32', fontSize: '1.8rem', margin: '0 0 16px' }}>🎉 Payment Successful!</h2>
            <p style={{ color: '#333', fontSize: '1.1rem', marginBottom: '8px' }}>Your account is now upgraded.</p>
            <p style={{ color: '#666', fontSize: '1rem', marginBottom: '24px' }}>Use this VIP Activation Code inside the Mobile App:</p>
            
            <div style={{ background: 'white', border: '2px dashed #4CAF50', padding: '16px', borderRadius: '12px', display: 'inline-block' }}>
              <span style={{ fontSize: '2rem', fontWeight: 800, color: '#1B5E20', letterSpacing: '2px' }}>{error}</span>
            </div>
            
            <p style={{ color: '#888', fontSize: '0.85rem', marginTop: '24px' }}>We have also sent this code to <b>{email}</b></p>
            <button onClick={() => window.location.reload()} style={{ marginTop: '16px', padding: '10px 24px', background: 'white', color: '#4CAF50', border: '1px solid #4CAF50', borderRadius: '8px', cursor: 'pointer' }}>Buy Another Code</button>
          </div>
        )}

        {/* How It Works */}
        <div style={{ background: 'white', borderRadius: '16px', padding: '24px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', marginBottom: '24px' }}>
          <h2 style={{ color: '#1B5E20', fontSize: '1.1rem', margin: '0 0 16px' }}>🔄 How It Works</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: '16px' }}>
            {[
              { icon: '1️⃣', title: 'Select Plan', desc: 'Choose your premium plan above' },
              { icon: '2️⃣', title: 'Pay Securely', desc: 'Pay via UPI, Card, or NetBanking' },
              { icon: '3️⃣', title: 'Get Code', desc: 'Activation code shown + emailed' },
              { icon: '4️⃣', title: 'Activate!', desc: 'Enter code in app → Premium ON' },
            ].map((s, i) => (
              <div key={i} style={{ textAlign: 'center' }}>
                <div style={{ fontSize: '32px', marginBottom: '4px' }}>{s.icon}</div>
                <div style={{ fontWeight: 700, color: '#1B5E20', fontSize: '14px' }}>{s.title}</div>
                <div style={{ fontSize: '12px', color: '#666' }}>{s.desc}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Refund & Trust */}
        <div style={{ background: 'white', borderRadius: '16px', padding: '24px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
          <h2 style={{ color: '#1B5E20', fontSize: '1.1rem', margin: '0 0 12px' }}>🛡️ Trust & Refund Policy</h2>
          <ul style={{ margin: 0, paddingLeft: '20px', color: '#555', fontSize: '14px', lineHeight: '2' }}>
            <li>✅ <b>7-day money-back guarantee</b> — no questions asked</li>
            <li>✅ Valid for <b>1 full year</b> from purchase date</li>
            <li>✅ Works on <b>2 devices</b> simultaneously</li>
            <li>✅ <b>5.00 ★ rating</b> on Google Play Store with 846+ users</li>
            <li>✅ Powered securely by <b>Razorpay</b></li>
            <li>📧 Support: <b>svknvs@gmail.com</b> | WhatsApp: <b>+91 86107 36302</b></li>
          </ul>
        </div>

      </div>
    </div>
  );
};

export default WebPremiumStorePage;
